module.exports = __webpack_public_path__ + "wechat.bc2031a5.png";